module.exports = __webpack_public_path__ + "img/facebook.dd0ef10e.svg";